/* eslint-disable no-nested-ternary */
/* eslint-disable */
import React, { useEffect } from 'react';
import { Box, TextField, Button, Grid, Card, CardContent, CardHeader, FormControlLabel, Checkbox } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { globalColor } from 'views/ConstantColors';
import { useBank } from 'hooks/api/terminology/bank/useBank';
import Swal from 'sweetalert2';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const BankSchema = Yup.object({
    name: Yup.string().required('Bank  name is required')
});

export const BankForm = ({ initialData, onClear }) => {
    const isEditMode = Boolean(initialData?.id);
    const { createBank, updateBank } = useBank();

    useEffect(() => {
        console.log('Form initialData changed:', initialData);
    }, [initialData]);

    const initialValues = {
        id: initialData?.id || 0,
        name: initialData?.name || '',
        isDeleted: initialData?.isDeleted ?? false,
        createdBy: initialData?.createdBy || '',
        lastModifiedBy: initialData?.lastModifiedBy || '',
        createdAt: initialData?.createdAt || new Date().toISOString(),
        lastModifiedAt: initialData?.lastModifiedAt || new Date().toISOString()
    };

    const handleFormSubmit = async (values, { setSubmitting, resetForm }) => {
        try {
            const formattedData = {
                id: values.id,
                name: values.name,
                isDeleted: values.isDeleted,
                createdBy: values.createdBy,
                lastModifiedBy: values.lastModifiedBy,
                createdAt: values.createdAt,
                lastModifiedAt: new Date().toISOString()
            };


            if (isEditMode && values.id && values.id !== 0) {
                await updateBank(values.id, formattedData);
                Swal.fire('Success', 'Bank updated successfully!', 'success');
            } else {
                await createBank(formattedData);
                Swal.fire('Success', 'Bank added successfully!', 'success');
                resetForm();
            }

            if (onClear) {
                onClear();
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            Swal.fire('Error', error.message || 'There was an error processing your request.', 'error');
        } finally {
            setSubmitting(false);
        }
    };

    const handleReset = (resetForm) => {
        resetForm();
        if (onClear) {
            onClear();
        }
    };

    return (
        <Card elevation={3} sx={{ mb: 4 }}>
            <CardHeader
                title={isEditMode ? 'Edit Bank' : 'Add New Bank'}
                sx={{
                    backgroundColor: globalColor,
                    color: 'white',
                    '.MuiCardHeader-title': { color: 'white', fontSize: '1.2rem', fontWeight: 'bold' }
                }}
            />
            <CardContent>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={BankSchema}
                        onSubmit={handleFormSubmit}
                        enableReinitialize
                        key={initialData?.id || 'new'}
                    >
                        {({ errors, touched, values, setFieldValue, resetForm, isSubmitting }) => (
                            <Form>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} md={6}>
                                        <Field
                                            as={TextField}
                                            fullWidth
                                            name="name"
                                            label="Bank Name"
                                            error={touched.name && Boolean(errors.name)}
                                            helperText={touched.name && errors.name}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                            <AnimateButton>
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    onClick={() => handleReset(resetForm)}
                                                    disabled={isSubmitting}
                                                    sx={{
                                                        borderColor: globalColor,
                                                        color: globalColor,
                                                        '&:hover': {
                                                            borderColor: 'rgb(0, 100, 0)',
                                                            color: 'rgb(0, 100, 0)'
                                                        }
                                                    }}
                                                >
                                                    {isEditMode ? 'Cancel' : 'Reset'}
                                                </Button>
                                            </AnimateButton>
                                            <AnimateButton>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    disabled={isSubmitting}
                                                    sx={{
                                                        bgcolor: globalColor,
                                                        '&:hover': {
                                                            bgcolor: 'rgb(0, 100, 0)'
                                                        }
                                                    }}
                                                >
                                                    {isSubmitting
                                                        ? isEditMode
                                                            ? 'Updating...'
                                                            : 'Adding...'
                                                        : isEditMode
                                                        ? 'Update Bank'
                                                        : 'Add Bank'}
                                                </Button>
                                            </AnimateButton>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Form>
                        )}
                    </Formik>
                </LocalizationProvider>
            </CardContent>
        </Card>
    );
};
